// @flow
import api, { buildHeaders } from 'common/services/api';
import PagedResults from 'statsradio/modules/pagination/domain/pagedResults';
import CampaignDashboardListing from 'common/modules/campaign/domain/CampaignDashboardListing';
import CampaignDashboardQuery from 'statsradio/modules/campaigns/domain/CampaignDashboardQuery';
import { PropositionSummaryQuery } from 'statsradio/modules/salesDashboard/domain/PropositionSummaryQuery';
import PropositionSummary from 'statsradio/modules/salesDashboard/domain/PropositionSummary';

class DashboardCampaignApi {

  async listUnlinkedCampaigns(token: string, callSign: string, query: CampaignDashboardQuery): Promise<PagedResults<CampaignDashboardListing>> {
    const url = `statsradio/${callSign}/campaigns/unlinked`;

    const { data } = await api.get(url, query.asQueryParams(), { headers: buildHeaders(token) });

    return PagedResults.parse(CampaignDashboardListing.parse, data);
  }

  async listRecentlyLinkedCampaigns(token: string, callSign: string, query: CampaignDashboardQuery): Promise<PagedResults<CampaignDashboardListing>> {
    const url = `statsradio/${callSign}/campaigns/recently-linked`;

    const { data } = await api.get(url, query.asQueryParams(), { headers: buildHeaders(token) });

    return PagedResults.parse(CampaignDashboardListing.parse, data);
  }

  async fetchPropositionDataSummary(token: string, callSign: string, query: PropositionSummaryQuery): Promise<PropositionSummary> {
    const url = `/statsradio/${callSign}/sales/propositions/summary`;
    const { data } = await api.get(url, query.asQueryParam(), { headers: buildHeaders(token) });

    return PropositionSummary.parse(data);
  }
}

export default new DashboardCampaignApi();



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/services/DashboardCampaignApi.js